// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Migration_PreflightFinanceiroResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract de GET /migration/financeiro/preflight
 * (controllers/migration/financeiro.php::preflight).
 *
 * Uma linha por agrupador de ESTRUTURA da franquia pedida, com o de-para ja
 * executado (tipo, grupo DRE, previsto, motivo de pulo), os blockers e se ja
 * veio. Leitura pura — nada foi escrito para montar isto.
 */
import type { Migration_PreflightFinanceiroRow } from './Migration_PreflightFinanceiroRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Migration_PreflightFinanceiroResponseDados {
registros: Migration_PreflightFinanceiroRow[]
}

export type Migration_PreflightFinanceiroResponse = ApiResponse<Migration_PreflightFinanceiroResponseDados>;

registerResponseContract('Migration_PreflightFinanceiroResponse', {
  registros: {
    type: 'array',
    required: true,
    items: {
      zoho_id:        { type: 'string',  required: false },
      nome:           { type: 'string',  required: false },
      tipo:           { type: 'string',  required: false },
      operacao:       { type: 'string',  required: false },
      grupo_dre:      { type: 'string',  required: false },
      valor_previsto: { type: 'number',  required: false },
      percentual:     { type: 'number',  required: false },
      n_categorias:   { type: 'number',  required: false },
      ja_migrado:     { type: 'boolean', required: false },
      sera_pulado:    { type: 'string',  required: false },
      blockers: {
        type: 'array',
        required: false,
        items: {
          code:     { type: 'string',  required: false },
          message:  { type: 'string',  required: false },
          severity: { type: 'string',  required: false },
          entity:   { type: 'string',  required: false },
          zoho_id:  { type: 'string',  required: false },
          label:    { type: 'string',  required: false },
        },
      },
    },
  },
})
